<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('common.requestedMode')"
    class="requested-mode-filter w-2"
    optional
  >
    <RygenMultiSelect
      :id="inputId"
      v-model="internalValue.requestedMode"
      :options="availableModes"
      :placeholder="t('common.requestedMode')"
      append-to="body"
      display="chip"
      option-label="label"
      option-value="value"
      filter
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { type PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { mapEnumToTranslatedDropdownValues } from '@rygen/rygen-ui/i18n';
import { Mode } from '@rygen/rygen-ui/model';

import { OrderSearchCriteria, ShipmentSearchCriteria } from '@/model';

import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';
import RygenMultiSelect from '@rygen/rygen-ui/components/form/RygenMultiSelect.vue';

const internalValue = defineModel({
  type: Object as PropType<OrderSearchCriteria | ShipmentSearchCriteria>,
  required: true,
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);
const { t } = useI18n();

const availableModes = mapEnumToTranslatedDropdownValues(Mode, 'Mode');
</script>
